import React from 'react';

interface GlobeIconProps {
  size?: number;
  color?: string;
}

/**
 * GlobeIcon Component
 * @description A globe/world icon representing global/domain status
 */
export const GlobeIcon: React.FC<GlobeIconProps> = ({ 
  size = 32, 
  color = '#009951' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 32 32"
    >
      <path 
        fill={color} 
        d="M11.667 16c0 1.098.049 2.162.14 3.178h8.386c.091-1.016.14-2.08.14-3.178s-.049-2.162-.14-3.178h-8.385A35 35 0 0 0 11.667 16m-1.599-3.178A37 37 0 0 0 9.933 16c0 1.09.047 2.153.134 3.178H3.391A13 13 0 0 1 3 16c0-1.096.136-2.16.391-3.178zm1.945-1.733h7.974c-.257-1.749-.645-3.308-1.126-4.59-.45-1.197-.965-2.107-1.491-2.701C16.842 3.202 16.377 3 16 3s-.842.202-1.37.797c-.527.595-1.041 1.505-1.491 2.703-.481 1.28-.87 2.84-1.127 4.589m9.92 1.733a37.28 37.28 0 0 1 0 6.356h6.677C28.864 18.16 29 17.096 29 16s-.136-2.16-.391-3.178zm6.109-1.733h-6.303c-.272-1.958-.701-3.727-1.254-5.199-.354-.94-.765-1.78-1.233-2.48a13.03 13.03 0 0 1 8.789 7.679m-17.778 0H3.96a13.03 13.03 0 0 1 8.789-7.679c-.468.7-.88 1.54-1.233 2.48-.553 1.472-.982 3.241-1.254 5.199m-.002 9.822h-6.3a13.03 13.03 0 0 0 8.782 7.678c-.468-.7-.878-1.54-1.23-2.479-.553-1.473-.981-3.241-1.252-5.199m8.606 4.59c.48-1.281.866-2.84 1.123-4.59h-7.978c.256 1.75.643 3.309 1.123 4.59.45 1.198.963 2.107 1.49 2.701.528.595.995.798 1.376.798s.848-.203 1.375-.798c.528-.594 1.041-1.503 1.49-2.701m1.623.608c.552-1.472.98-3.241 1.25-5.198h6.301a13.03 13.03 0 0 1-8.782 7.678c.468-.7.878-1.541 1.23-2.48"
      />
    </svg>
  );
};

export default GlobeIcon;

